<template>
    <div>
        <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
            <el-button size="small" type="danger" @click="savePageConfig()">保 存</el-button>
        </div>
        <el-form :model="pageConfig" :rules="rules" label-width="120px">
            <el-form-item label="颜色一" prop="color1">
                <el-input v-model="pageConfig.color1" placeholder="颜色一"></el-input>
            </el-form-item>
            <el-form-item label="颜色二" prop="color2">
                <el-input v-model="pageConfig.color2" placeholder="颜色二"></el-input>
            </el-form-item>
            <el-form-item label="连接地址" prop="activeUrl">
                <el-input v-model="pageConfig.activeUrl" placeholder="连接地址"></el-input>
            </el-form-item>
            <el-form-item label="摘要" prop="activeSummary">
                <el-input v-model="pageConfig.activeSummary" placeholder="摘要"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="activeContent">
                <el-input v-model="pageConfig.activeContent" type="textarea" :rows="3" placeholder="内容"></el-input>
            </el-form-item>

        </el-form>
    </div>

</template>

<script>
    import {getActivePageApi,saveActivePageApi } from "../../api/api";

    export default {
        //name: "pageConfig",
        data(){
            var validateDate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value <= this.active.beginTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                }else {
                    callback();
                }
            };
            var validateDate2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value >= this.active.endTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                }else {
                    callback();
                }
            };
            return {
                rules: {
                    activeName: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    beginTime: [
                        { type: 'string', required: true, message: '请选择日期', trigger: 'change' }
                    ],
                    endTime: [
                        { type: 'string', required: true, message: '请选择结束日期', trigger: 'change' },
                        { validator: validateDate, trigger: 'blur' }
                    ],
                    inviteNum:[
                        { type: 'number', message: '必须为数字'}
                    ],
                    joinNum: [
                        {required: true, message: '请输参团人数', trigger: 'blur'},
                        {min: 1, max: 10, message: '参团人数在1-10之间', trigger: 'blur'}
                    ],
                    grouponHour: [
                        {required: true, message: '拼团超时时间', trigger: 'blur'},
                        {min: 1, max: 48, message: '拼团超时时间在1-48小时之间', trigger: 'blur'}
                    ],
                    activeUrl: [
                        {required: true, message: '必须输入连接地址', trigger: 'blur'},
                        {min: 1, max: 256, message: '长度在 5 到 60 个字符', trigger: 'blur'}
                    ],
                    activeContent:[
                        {min: 1, max: 500, message: '长度在 5 到 60 个字符', trigger: 'blur'}
                    ]
                },
                pageConfig: {
                    activePageId: '',
                    activeNo: this.$route.query.activeNo,
                    activeSummary: '',
                    /*跳转连接*/
                    activeUrl: '',
                    /*平台标示*/
                    color1: '',
                    color2: '',
                    /*是否会员*/
                    isvip: 0,
                    /*会员权益*/
                    vipRightType: '0',
                    activeContent: ''
                },
            }
        },
        mounted(){
            this.getActivePage();
        },
        methods: {
            getActivePage() {
                this.loading = true;
                this.pageConfig.activeUrl = '';
                getActivePageApi({activeNo: this.pageConfig.activeNo}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        if (res.data.value != null) {
                            this.pageConfig = res.data.value;
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            savePageConfig() {
                if (this.pageConfig.activeUrl == '') {
                    this.$message({
                        showClose: true,
                        message: 'url必填',
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                saveActivePageApi(this.pageConfig).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showPageDialog = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/active/pageConfig.vue